<!-- <div class="home-container"></div> -->
  <!-- <nav-bar style="z-index: 1000"></nav-bar> -->

  <div *ngIf="auth.user$ | async as user; else elseBlock" class="content-container">
    <!-- Layout contenitore principale -->
    <div class="fixed-width-container">
      <!-- Dashboard o Richieste in base al ruolo dell'utente -->
      <div class="component-wrapper">
        <app-dashboard *ngIf="showDashboard"></app-dashboard>
        <!-- L'app-richieste non è più necessario qui poiché viene fatto un redirect -->
      </div>
    </div>
  </div>

  <p-toast position="top-center"></p-toast>

  <ng-template #elseBlock>
    <home-not-logged></home-not-logged>
  </ng-template>
